import { lazy } from 'react'

import { ArrowLeft } from '@factorialco/f0-react/icons/app'
import { TrainingDetailPageDocument } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'
import type { NavigationRoutesFn } from 'modules/core/lib/react-router'

const Root = lazy(() => import('modules/trainings/pages/content/Root'))
const Builder = lazy(() => import('modules/trainings/pages/content/Builder'))

export const contentRoutes: NavigationRoutesFn = (navigation) => {
  const contentRoot = navigation.trainings.list.details_revamp.content
  return [
    {
      path: contentRoot.path,
      element: <Root />,
      handle: {
        resource: true,
        meta({ watchQuery, params, session }) {
          return watchQuery({
            // TODO Use own query
            query: TrainingDetailPageDocument,
            fetchPolicy: 'cache-and-network',
            variables: {
              trainingId: Number(params.id),
              resourceId: String(params.id),
              companyId: session.company.id,
            },
          }).map(({ data }) => {
            const training = data.trainings.training
            return {
              headerComponentProps: {
                title: String(training?.name),
                primaryAction: {
                  key: 'save',
                  label: i18n.t('common.save'),
                },
                secondaryActions: [
                  {
                    key: 'back',
                    icon: ArrowLeft,
                    label: i18n.t('trainings.content.builder.back'),
                  },
                ],
              },
              title: i18n.t('trainings.content.builder.page_title'),
              subNavigation: [],
            }
          })
        },
      },
      children: [
        {
          path: contentRoot.builder.path,
          element: <Builder />,
        },
      ],
    },
  ]
}
